import {
    BOOKING_ATTEMPTS_ERROR_ACTION_TYPE,
    BOOKING_ATTEMPTS_FETCH_START_ACTION_TYPE,
    BOOKING_ATTEMPTS_FETCH_SUCCESS_ACTION_TYPE,
    BOOKING_ATTEMPTS_METRICS_FETCH_START_ACTION_TYPE,
    BOOKING_ATTEMPTS_METRICS_FETCH_SUCCESS_ACTION_TYPE,
    BOOKING_ATTEMPTS_RESET_ACTION_TYPE,
    BookingAttemptsAction
} from 'actions/bookingAttempts/BookingAttemptsActionsTypes';
import { BookingAttemptsState, BookingAttemptsStatus } from 'reducers/bookingAttempts/BookingAttemptsState';
import { Reducer } from 'redux';

const initialState: BookingAttemptsState = {
    loading: false,
    status: BookingAttemptsStatus.Initial,
    bookingAttempts: []
};

export const bookingAttemptsReducer: Reducer<BookingAttemptsState, BookingAttemptsAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case BOOKING_ATTEMPTS_RESET_ACTION_TYPE:
            return {
                ...initialState
            };

        case BOOKING_ATTEMPTS_ERROR_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: BookingAttemptsStatus.Error
            };

        case BOOKING_ATTEMPTS_FETCH_START_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: BookingAttemptsStatus.FetchStart
            };

        case BOOKING_ATTEMPTS_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: BookingAttemptsStatus.FetchSuccess,
                bookingAttempts: action.payload.bookingAttempts,
                pagination: action.payload.pagination
            };

        case BOOKING_ATTEMPTS_METRICS_FETCH_START_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: BookingAttemptsStatus.MetricsFetchStart
            };

        case BOOKING_ATTEMPTS_METRICS_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: BookingAttemptsStatus.MetricsFetchSuccess,
                metrics: action.payload.metrics
            };

        default:
            return state;
    }
};

export default bookingAttemptsReducer;
